import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

// ─────────────────────────────────────────────────────────────────────────────

export const useProductDetailsNavigationHeaderHeight = () => {
  const { top: safeAreaTopInset } = useSafeAreaInsets();
  const topOffset = Platform.select({ android: safeAreaTopInset, default: 0 });

  return NAV_HEADER_HEIGHT + topOffset;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const NAV_HEADER_HEIGHT = 72;
